export const normalizeBillingEmail = (email) =>
  String(email || "").trim().toLowerCase();

/**
 * Prevent unverified billing contact email changes from being submitted on save.
 * The backend enforces the same rule; this keeps the UI in sync immediately.
 */
export const sanitizeBillingPayload = (billingPayload, currentCustomer) => {
  const savedEmail = currentCustomer?.billing?.billingContact?.email || "";
  const draftEmail = billingPayload?.billingContact?.email ?? savedEmail;

  if (normalizeBillingEmail(draftEmail) === normalizeBillingEmail(savedEmail)) {
    return { billing: billingPayload, rejected: false };
  }

  return {
    billing: {
      ...billingPayload,
      billingContact: {
        ...billingPayload.billingContact,
        email: savedEmail,
      },
    },
    rejected: true,
  };
};
